import apiService from "../../../../service/Api";

export interface SEOPageVariableApiItem {
  id: number;
  key: string;
  label: string;
  sample: string;
  display_order: number;
}

export interface SEOPageDefinitionApiItem {
  id: number;
  site: number;
  page_key: string;
  label: string;
  path_pattern: string;
  is_dynamic: boolean;
  is_active: boolean;
  variables: SEOPageVariableApiItem[];
}

export interface SEOPageDefinitionsApiResponse {
  results: SEOPageDefinitionApiItem[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const fetchSeoPageDefinitions = (siteId: number) =>
  apiService.get<SEOPageDefinitionsApiResponse>(
    `/api/configurations/seo-page-definitions/?site=${siteId}&page_size=1000`,
  );
